export enum MainSmsIntegrationTypeEnum {
  SMS = 'SMS',
  EMAIL = 'EMAIL'
}
